import { z } from 'zod';
import { PrevisitWorkflowStatusSchema } from './workflowStatus.js';
/** Route params for the staff endpoints addressing a single previsit form set. */
export const PrevisitFormSetIdParamsSchema = z.object({ previsitFormSetId: z.uuid() }).strict();
/** The authentication code lets a staff user open the patient's link, so asking for it is audited. */
export const PrevisitFormSetFindOneQuerySchema = z
    .object({
    includeAuthenticationCode: z.stringbool({ truthy: ['true'], falsy: ['false'] }).default(false),
})
    .strict();
/** A form set hangs off exactly one of the two entities, so a lookup names at least one of them. */
export const PrevisitFormSetFindByEntityQuerySchema = z.union([
    z
        .object({
        encounterId: z.uuid().nullable().optional(),
        ehrInformationId: z.uuid(),
        includeAuthenticationCode: z
            .stringbool({ truthy: ['true'], falsy: ['false'] })
            .default(false),
    })
        .strict(),
    z
        .object({
        encounterId: z.uuid(),
        ehrInformationId: z.uuid().nullable().optional(),
        includeAuthenticationCode: z
            .stringbool({ truthy: ['true'], falsy: ['false'] })
            .default(false),
    })
        .strict(),
]);
/** Template id to the parameters the template is rendered with, both free-form to the template. */
export const PrevisitFormSetTemplateParametersSchema = z.record(z.uuid(), z.record(z.string(), z.string()));
export const PrevisitFormSetCreateSchema = z.union([
    z
        .object({
        ehrInformationId: z.uuid(),
        formTemplates: PrevisitFormSetTemplateParametersSchema,
    })
        .strict(),
    z
        .object({
        encounterId: z.uuid(),
        formTemplates: PrevisitFormSetTemplateParametersSchema,
    })
        .strict(),
]);
export const PrevisitFormSetExpireSchema = z
    .object({ previsitFormSetIds: z.array(z.uuid()) })
    .strict();
/** Shared by every manual outreach endpoint: send all, sms, email and voice. */
export const PrevisitFormSetOutreachSchema = z
    .object({
    checkRateLimiter: z.boolean().default(true),
    checkDuplicates: z.boolean().default(true),
})
    .strict();
/** Notification content is the message the patient received, so asking for it is audited. */
export const PrevisitFormSetFindPatientNotificationsQuerySchema = z
    .object({
    includeContent: z.stringbool({ truthy: ['true'], falsy: ['false'] }).default(false),
})
    .strict();
export const PrevisitFormSetGetFormQuerySchema = z
    .object({ previsitFormTemplateName: z.string().min(1).optional() })
    .strict();
export const PrevisitFormSetWorkflowEventCreateSchema = z
    .object({
    status: PrevisitWorkflowStatusSchema,
    reasonsForReview: z.array(z.string().min(1)).optional(),
})
    .strict();
//# sourceMappingURL=set.js.map